import type {Theme} from "@mui/material/styles";

const COLOR = /#(?:[0-9a-fA-F]{6}|[0-9a-fA-F]{3})\b|"(?:white|black)"/g;

const luminance = (color: string) => {
    if (color === '"white"') return 1;
    if (color === '"black"') return 0;
    let hex = color.slice(1);
    if (hex.length === 3) hex = hex.split("").map((c) => c + c).join("");
    const [r, g, b] = [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16) / 255);
    return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

// Course logos are monochrome SVGs: dark fill (#0F172A) with white outlines that separate shapes.
// In dark mode swap them: dark → light text color, white → paper color, so the outlines stay invisible.
export const themeLogoSvg = (svg: string, theme: Theme): string => {
    if (theme.palette.mode !== "dark" || !svg.trim().startsWith("<svg")) {
        return svg;
    }

    return svg.replace(COLOR, (color) => {
        const quoted = color.startsWith('"');
        const value = luminance(color);
        if (value < 0.2) return quoted ? `"${theme.palette.text.primary}"` : theme.palette.text.primary;
        if (value > 0.9) return quoted ? `"${theme.palette.background.paper}"` : theme.palette.background.paper;
        return color;
    });
};
